// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
}

:root {
  --bg-0:    #1f1f1f;   /* page background */
  --panel:   #3e3e3e;   /* side panels */
  --panel-2: #2f2f2f;   /* darker panels / toolbar */
  --muted:   #d9dccc;   /* pale input background */
  --accent:  #9c9b7f;   /* primary button / tan */
  --accent-2:#a8d8ff;   /* small highlight / info colour */
  --text:    #e6e6e6;
}

body, .App {
  background: var(--bg-0);
  color: var(--text);
}

/* ── Top navigation bar ─────────────────────────────────── */
.top-nav {
  background: linear-gradient(180deg, var(--panel-2), var(--panel));
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  padding-top: 12px;
  padding-bottom: 12px;
  height: 64px;
}

/* ── Primary action button (used in DiagramToolbar, ToolPalette) */
.btn-primary {
  background: var(--accent);
  color: #222;
  padding-left: 1rem;
  padding-right: 1rem;
  border-radius: 999px;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(156, 155, 127, 0.15);
}
.btn-primary:hover {
  filter: brightness(0.92);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(156, 155, 127, 0.25);
}
.btn-primary:active {
  filter: brightness(0.85);
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(156, 155, 127, 0.15);
}

/* ── Muted secondary button ─────────────────────────────── */
.btn-muted {
  background: #404040;
  color: var(--muted);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}
.btn-muted:hover {
  background: #4a4a4a;
  transform: translateY(-1px);
}
.btn-muted:active {
  transform: translateY(0);
}

/* ── Animations ─────────────────────────────────────────── */
@keyframes modalBackdropIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(12px);
  }
}

@keyframes modalBackdropOut {
  from {
    opacity: 1;
    backdrop-filter: blur(12px);
  }
  to {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
}

@keyframes modalScaleIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.9) rotate(-2deg);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1) rotate(0deg);
  }
}

@keyframes modalScaleOut {
  from {
    opacity: 1;
    transform: translateY(0) scale(1) rotate(0deg);
  }
  to {
    opacity: 0;
    transform: translateY(40px) scale(0.9) rotate(-2deg);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideDown {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(20px);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes fadeOut {
  from { opacity: 1; }
  to { opacity: 0; }
}

/* ── Modal overlay (used in CodeImportModal, LoginModal) ── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  /* Prevent scroll on body while modal is open */
  overflow: hidden;
}

.modal-overlay.in {
  animation: modalBackdropIn 300ms ease-out forwards;
}

.modal-overlay.out {
  animation: modalBackdropOut 300ms ease-in forwards;
}

/* ── Login card ─────────────────────────────────────────── */
.login-card {
  width: 420px;
  background: linear-gradient(180deg, #3f3f3f, #343434);
  border-radius: 28px;
  padding: 44px 36px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6), 0 0 40px rgba(156, 155, 127, 0.15);
  text-align: center;
}

.login-card.in {
  animation: modalScaleIn 400ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.login-card.out {
  animation: modalScaleOut 300ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}
.login-logo {
  font-size: 28px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-logo img {
  height: 64px;
  width: auto;
  margin: 0 auto 8px auto;
  display: block;
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
}
.login-input {
  width: 320px;
  height: 46px;
  border-radius: 22px;
  background: var(--muted);
  border: 2px solid transparent;
  padding: 0 18px;
  outline: none;
  color: #222;
  font-size: 14px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.login-input:focus {
  transform: translateY(-2px);
  box-shadow: 0 0 0 2px var(--accent), 0 8px 20px rgba(156, 155, 127, 0.2);
  border-color: var(--accent);
}
.login-help {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin-top: 6px;
  cursor: pointer;
}
.login-help:hover { color: rgba(255, 255, 255, 0.9); }
.login-btn {
  background: var(--accent);
  color: #222;
  border: none;
  border-radius: 18px;
  padding: 8px 36px;
  margin-top: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  width: 320px;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(156, 155, 127, 0.25);
  position: relative;
  overflow: hidden;
}
.login-btn:hover {
  filter: brightness(0.92);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(156, 155, 127, 0.35);
}
.login-btn:active {
  filter: brightness(0.85);
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(156, 155, 127, 0.2);
}
.login-or {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  margin-top: 8px;
  width: 100%;
}
.login-or span {
  flex: 1 1;
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
}
.login-socials {
  display: flex;
  gap: 18px;
  margin-top: 8px;
}
.social-btn {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text);
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
.social-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(156, 155, 127, 0.2);
}
.social-btn:active {
  transform: translateY(0) scale(0.98);
}
.create-account {
  color: rgba(255, 255, 255, 0.7);
  margin-top: 10px;
  font-size: 13px;
}

/* ── Editor layout helpers ──────────────────────────────── */
main        { background: transparent; }
.h-screen   { background: var(--bg-0); }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB,IAAI,oBAAoB;EAC1C,kBAAkB,IAAI,gBAAgB;EACtC,kBAAkB,IAAI,4BAA4B;EAClD,kBAAkB,IAAI,0BAA0B;EAChD,kBAAkB,IAAI,yBAAyB;EAC/C,kBAAkB,IAAI,kCAAkC;EACxD,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,iEAAiE;EACjE,kDAAkD;EAClD,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gDAAgD;AAClD;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA,8DAA8D;AAC9D;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,oDAAoD;EACtD;EACA;IACE,UAAU;IACV,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,UAAU;IACV,8CAA8C;EAChD;EACA;IACE,UAAU;IACV,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;EACnB,kBAAkB;EAClB,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,yEAAyE;AAC3E;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,WAAW;EACX,eAAe;EACf,kDAAkD;EAClD,wCAAwC;AAC1C;AACA;EACE,2BAA2B;EAC3B,wEAAwE;EACxE,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA,oBAAoB,+BAA+B,EAAE;AACrD;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kDAAkD;EAClD,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gDAAgD;AAClD;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,kDAAkD;AACpD;AACA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,+CAA+C;AACjD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8DAA8D;AAC9D,cAAc,uBAAuB,EAAE;AACvC,cAAc,uBAAuB,EAAE","sourcesContent":[".App {\n  min-height: 100vh;\n}\n\n:root {\n  --bg-0:    #1f1f1f;   /* page background */\n  --panel:   #3e3e3e;   /* side panels */\n  --panel-2: #2f2f2f;   /* darker panels / toolbar */\n  --muted:   #d9dccc;   /* pale input background */\n  --accent:  #9c9b7f;   /* primary button / tan */\n  --accent-2:#a8d8ff;   /* small highlight / info colour */\n  --text:    #e6e6e6;\n}\n\nbody, .App {\n  background: var(--bg-0);\n  color: var(--text);\n}\n\n/* ── Top navigation bar ─────────────────────────────────── */\n.top-nav {\n  background: linear-gradient(180deg, var(--panel-2), var(--panel));\n  border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n  padding-top: 12px;\n  padding-bottom: 12px;\n  height: 64px;\n}\n\n/* ── Primary action button (used in DiagramToolbar, ToolPalette) */\n.btn-primary {\n  background: var(--accent);\n  color: #222;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  border-radius: 999px;\n  padding-top: 0.4rem;\n  padding-bottom: 0.4rem;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n  box-shadow: 0 2px 8px rgba(156, 155, 127, 0.15);\n}\n.btn-primary:hover {\n  filter: brightness(0.92);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(156, 155, 127, 0.25);\n}\n.btn-primary:active {\n  filter: brightness(0.85);\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(156, 155, 127, 0.15);\n}\n\n/* ── Muted secondary button ─────────────────────────────── */\n.btn-muted {\n  background: #404040;\n  color: var(--muted);\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.btn-muted:hover {\n  background: #4a4a4a;\n  transform: translateY(-1px);\n}\n.btn-muted:active {\n  transform: translateY(0);\n}\n\n/* ── Animations ─────────────────────────────────────────── */\n@keyframes modalBackdropIn {\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n  to {\n    opacity: 1;\n    backdrop-filter: blur(12px);\n  }\n}\n\n@keyframes modalBackdropOut {\n  from {\n    opacity: 1;\n    backdrop-filter: blur(12px);\n  }\n  to {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n}\n\n@keyframes modalScaleIn {\n  from {\n    opacity: 0;\n    transform: translateY(40px) scale(0.9) rotate(-2deg);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1) rotate(0deg);\n  }\n}\n\n@keyframes modalScaleOut {\n  from {\n    opacity: 1;\n    transform: translateY(0) scale(1) rotate(0deg);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(40px) scale(0.9) rotate(-2deg);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes fadeOut {\n  from { opacity: 1; }\n  to { opacity: 0; }\n}\n\n/* ── Modal overlay (used in CodeImportModal, LoginModal) ── */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  /* Prevent scroll on body while modal is open */\n  overflow: hidden;\n}\n\n.modal-overlay.in {\n  animation: modalBackdropIn 300ms ease-out forwards;\n}\n\n.modal-overlay.out {\n  animation: modalBackdropOut 300ms ease-in forwards;\n}\n\n/* ── Login card ─────────────────────────────────────────── */\n.login-card {\n  width: 420px;\n  background: linear-gradient(180deg, #3f3f3f, #343434);\n  border-radius: 28px;\n  padding: 44px 36px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6), 0 0 40px rgba(156, 155, 127, 0.15);\n  text-align: center;\n}\n\n.login-card.in {\n  animation: modalScaleIn 400ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n\n.login-card.out {\n  animation: modalScaleOut 300ms cubic-bezier(0.34, 1.56, 0.64, 1) forwards;\n}\n.login-logo {\n  font-size: 28px;\n  color: var(--muted);\n  font-weight: 600;\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login-logo img {\n  height: 64px;\n  width: auto;\n  margin: 0 auto 8px auto;\n  display: block;\n}\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  align-items: center;\n}\n.login-input {\n  width: 320px;\n  height: 46px;\n  border-radius: 22px;\n  background: var(--muted);\n  border: 2px solid transparent;\n  padding: 0 18px;\n  outline: none;\n  color: #222;\n  font-size: 14px;\n  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n.login-input:focus {\n  transform: translateY(-2px);\n  box-shadow: 0 0 0 2px var(--accent), 0 8px 20px rgba(156, 155, 127, 0.2);\n  border-color: var(--accent);\n}\n.login-help {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  margin-top: 6px;\n  cursor: pointer;\n}\n.login-help:hover { color: rgba(255, 255, 255, 0.9); }\n.login-btn {\n  background: var(--accent);\n  color: #222;\n  border: none;\n  border-radius: 18px;\n  padding: 8px 36px;\n  margin-top: 6px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  width: 320px;\n  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(156, 155, 127, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n.login-btn:hover {\n  filter: brightness(0.92);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(156, 155, 127, 0.35);\n}\n.login-btn:active {\n  filter: brightness(0.85);\n  transform: translateY(0);\n  box-shadow: 0 2px 6px rgba(156, 155, 127, 0.2);\n}\n.login-or {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14px;\n  margin-top: 8px;\n  width: 100%;\n}\n.login-or span {\n  flex: 1;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.06);\n}\n.login-socials {\n  display: flex;\n  gap: 18px;\n  margin-top: 8px;\n}\n.social-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 22px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text);\n  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.social-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n  transform: translateY(-2px) scale(1.05);\n  box-shadow: 0 4px 12px rgba(156, 155, 127, 0.2);\n}\n.social-btn:active {\n  transform: translateY(0) scale(0.98);\n}\n.create-account {\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 10px;\n  font-size: 13px;\n}\n\n/* ── Editor layout helpers ──────────────────────────────── */\nmain        { background: transparent; }\n.h-screen   { background: var(--bg-0); }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
